import React from 'react';
import { Menu, Transition } from '@headlessui/react';
import IconButton from '../basicComponents/IconButton';
import { useIcons } from '../../utils/hooks';
import { MainAppContext } from '../../MainAppContext';

function LanguageMenu({
	selected,
	items = [],
	colors,
	displayType
}) {
	/* Icon hook */
	const { ArrowDown } = useIcons(colors);

	/* Default values for the styles */
	const defaultStyleSHADOW = open => ({
		backgroundColor: colors?.background,
		boxShadow: open && '0 1px 1px 0 rgba(0, 0, 0, 0.5)',
	});

	const {
		formData,
		formDataIni,
		setFormData,
		setFormDataIni
	} = React.useContext(MainAppContext);

	const changeLanguage = item => {
		item.action();
		setFormData({
			...formData,
			language: item.key
		});
		setFormDataIni({
			...formDataIni,
			language: item.key
		});
	};


	return (<Menu as='div' className='absolute font-lato top-6 right-9 z-50 hidden md:flex'>
		{({ open }) => (
			<div
				className='flex group flex-col'
				style={defaultStyleSHADOW(open)}
			>
				{/* BUTTON */}
				<Menu.Button className={`flex justify-between text-center align-middle items-baseline 
										space-x-2 ml-6 mt-8 mr-3 mb-9 focus:outline-none`}>
					{displayType === 'initials' ?
						<p>{selected?.key.toUpperCase()}</p>
						:
						<img src={selected?.icon} />
					}
					{ArrowDown && ArrowDown({
						className: `${open && 'transform rotate-180 opacity-100'} opacity-0 group-hover:opacity-100`
					})}
				</Menu.Button>
				{/* LIST */}
				<Transition
					as={React.Fragment}
					show={open}
					enter="transition ease-out duration-300"
					enterFrom="transform opacity-0"
					enterTo="transform opacity-100"
					leave="transition ease-in duration-100"
					leaveFrom="transform opacity-300"
					leaveTo="transform opacity-0"
				>
					<Menu.Items
						className='space-y-5 pt-4 pb-12 pl-5 focus:outline-none'
					>
						{
							items.map(item => (
								<Menu.Item key={item.key}>
									{displayType === 'initials' ?
										<p
											onClick={() => changeLanguage(item)}
											style={{
												cursor: 'pointer'
											}}>
											{item.key.toUpperCase()}
										</p>
										:
										<IconButton
											icon={item.icon}
											classNameBTN='block'
											onClick={() => changeLanguage(item)}
										/>
									}
								</Menu.Item>
							))
						}
					</Menu.Items>
				</Transition>

			</div>
		)}
	</Menu>
	);
}

export default LanguageMenu;
